// extracted by mini-css-extract-plugin
module.exports = {"column":"Footer_column__m7Qn1","list_item":"Footer_list_item__xIVwi","column_heading":"Footer_column_heading__N3VGJ","social_link_item":"Footer_social_link_item__JFobF"};